import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CpsPrompt = _resolveComponent("CpsPrompt")!
  const _component_BaseLayout = _resolveComponent("BaseLayout")!

  return (_openBlock(), _createBlock(_component_BaseLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_CpsPrompt, {
        title: _ctx.prompt.title,
        content: _ctx.prompt.content,
        icon: _ctx.prompt.icon,
        value: _ctx.prompt.isShow,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.prompt.isShow) = $event))
      }, null, 8, ["title", "content", "icon", "value"]),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.stateComponent)))
    ]),
    _: 1
  }))
}